var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4"},[(this.$i18n.locale === 'ru')?[_c('PrivacyNestRu')]:[_c('PrivacyNestEn')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }